import { render, staticRenderFns } from "./Tuikuan.vue?vue&type=template&id=f57b0398&scoped=true&"
import script from "./Tuikuan.vue?vue&type=script&lang=ts&"
export * from "./Tuikuan.vue?vue&type=script&lang=ts&"
import style0 from "./Tuikuan.vue?vue&type=style&index=0&id=f57b0398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57b0398",
  null
  
)

export default component.exports